var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectLiveDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon/xl/Success/Light circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#34C266"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M48 26.1602V28.0002C47.9975 32.3131 46.601 36.5096 44.0187 39.9639C41.4363 43.4182 37.8066 45.9452 33.6707 47.168C29.5349 48.3909 25.1145 48.244 21.0689 46.7494C17.0234 45.2548 13.5693 42.4924 11.2219 38.8744C8.87453 35.2563 7.75958 30.9763 8.04335 26.6728C8.32712 22.3693 9.99441 18.2729 12.7966 14.9944C15.5987 11.7159 19.3856 9.43098 23.5924 8.48051C27.7992 7.53004 32.2005 7.96489 36.14 9.72022M48 12.0002L28 32.0202L22 26.0202",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectLiveDouble);
export default __webpack_public_path__ + "static/media/correct-live-double.ec49d959f1568beab02c7e6e8ee3285d.svg";
export { ForwardRef as ReactComponent };